import { FormControl, FormHelperText, TextField } from '@mui/material';

interface TxtTipoUsuarioProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  helperText?: string;
  required?: boolean;
  name?: string;
  disabled?: boolean;
}

export const TxtTipoUsuario = ({ value, onChange, helperText, required = false, name = 'categoria', disabled = false }: TxtTipoUsuarioProps) => {
  return (
    <FormControl fullWidth size="small">
      <TextField select required={required} size="small" name={name} value={value} onChange={onChange} SelectProps={{ native: true }} disabled={disabled}>
        <option value="">Selecione o tipo de usuário</option>
        <option value="USUARIO">USUÁRIO</option>
        <option value="ADMINISTRADOR">ADMINISTRADOR</option>
      </TextField>

      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
